import { handleActions } from 'redux-actions';
import { defaultBlockedUsernamesWidgetState } from './defaults';
import { BlockedUsernamesWidgetData } from './types';
import { initSecurityPage } from '../../actions';
import {
  makeSpecificSaveableWidgetDataMergeFunction,
  saveRequestMetaReducer,
} from '../utils';
import {
  saveBlockedUsernames,
  saveBlockedUsernamesFailure,
  saveBlockedUsernamesSuccess,
  setBlockedUsernamesWidgetBlockedUsers,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

const mergeBlockedUsernamesWidgetDataChange =
  makeSpecificSaveableWidgetDataMergeFunction(
    defaultBlockedUsernamesWidgetState
  );

export default handleActions<BlockedUsernamesWidgetData, any>(
  {
    [initSecurityPage.toString()]: (
      state,
      action: ReturnType<typeof initSecurityPage>
    ) => {
      const data: BlockedUsernamesWidgetData['initialData'] = {
        blockedUsers: action.payload.data.blockedUsers.map(
          user => user.username
        ),
      };
      return {
        initialData: data,
        currentData: data,
        isDirty: false,
        saveRequest: {
          status: NetworkRequestState.IDLE,
        },
      };
    },
    [setBlockedUsernamesWidgetBlockedUsers.toString()]: (
      state,
      action: ReturnType<typeof setBlockedUsernamesWidgetBlockedUsers>
    ) =>
      mergeBlockedUsernamesWidgetDataChange(state, {
        blockedUsers: action.payload.blockedUsernames,
      }),
    ...saveRequestMetaReducer({
      initialAction: saveBlockedUsernames,
      successAction: saveBlockedUsernamesSuccess,
      failureAction: saveBlockedUsernamesFailure,
    }),
  },
  defaultBlockedUsernamesWidgetState
);
